import { render, staticRenderFns } from "./CookieBox.vue?vue&type=template&id=6c233bf9&scoped=true&"
import script from "./CookieBox.vue?vue&type=script&lang=js&"
export * from "./CookieBox.vue?vue&type=script&lang=js&"
import style0 from "./CookieBox.vue?vue&type=style&index=0&id=6c233bf9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c233bf9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c233bf9')) {
      api.createRecord('6c233bf9', component.options)
    } else {
      api.reload('6c233bf9', component.options)
    }
    module.hot.accept("./CookieBox.vue?vue&type=template&id=6c233bf9&scoped=true&", function () {
      api.rerender('6c233bf9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2yo0elvf8uTWF/JS/comp/CookieBox.vue"
export default component.exports